type Range = [number, number];

export const clamp = (value: number, [min, max]: Range): number =>
  Math.max(Math.min(value, max), min);
